import React, { useState, useEffect, useContext  } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, NavItem, NavLink, Collapse, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';



import InnerHeader from "../InnerHeader/InnerHeader";

import LanguageContext from "../../views/languageContext/LanguageContext";

const Header = () => {
    const {t} = useTranslation();


     const {language,changeLanguage} = useContext(LanguageContext)

    const languageImages = {
        english: require('../../assets/images/us.svg').default,
        french: require('../../assets/images/egypt.svg').default,
        Portuguese: require('../../assets/images/afghanistan.svg').default,
    };

    useEffect(() => {
        const languageClasses = {
          english: 'english',
          french: 'french',
          Portuguese: 'Portuguese',
        };
    
        document.body.className = '';

        if (languageClasses[language]) {
          document.body.classList.add(languageClasses[language]);
        }
    
        return () => {
          document.body.className = '';
        };
      }, [language]); 

    const [isActive, setIsActive] = useState(false);
    const toggleMenu = () => {
        setIsActive(!isActive);
    };

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
    }, []);

    const [activeItem, setActiveItem] = useState(''); // Initialize active item state
    const navigate = useNavigate();
    // Function to handle click events on menu items
   
    const menuItems = [
        { id: 'token', name: 'Token' ,naviagetto:'#tokensale'},
        { id: 'roadmap', name: 'Roadmap', naviagetto:'#roadmap' },
        { id: 'faq', name: 'FAQ',naviagetto:'#faq' },
        { id: 'hiw', name: 'How it works',naviagetto:'/keynotes' },
        // { id: 'contact', name: 'Contact',naviagetto:'#about' },
        { id: 'whitepaper', name: 'Whitepaper',naviagetto:'/whitepaper' },

    ];


    React.useEffect(() => { window.scrollTo(0, 0); }, []);


 

    const pageTo = (section) => {
        navigate('/');

        setTimeout(() => {
            const element = document.querySelector(section);
            if (element) {
                window.scrollBy({
                    top: element.getBoundingClientRect().top - 40,
                    behavior: 'smooth',
                });
            }
        }, 100); 
    };

    const handleItemClick = (item,id) => {
        console.log("🦁 ~ handleItemClick ~ item:", item)
        setActiveItem(id); // Update active item state
       // pageTo(`${item}`);

        if(item === "/keynotes"){
            navigate("/keynotes")
        }
        else if(item === "/whitepaper"){
           navigate("/whitepaper")
        }
        else{
        pageTo(`${item}`);
        }
    };
  

    return (
        <header id="homeheader" className={scroll ? "indHd hdrFd scroll" : "indHd hdrFd"}>
            <nav className={isActive ? "navbar navbar-expand-xl fixed-top sbMenu" : "navbar navbar-expand-xl fixed-top"}>
                <div className="container NavCntrBrd">
                    <a className="navbar-brand" href="/"><img src={require('../../assets/images/logo.png')} alt="logo" /></a>
                    <div className="hdNavMenu w-100">
                        

                        {sessionStorage.getItem('user_JWT') ?
                            <InnerHeader />
                            :
                            <Collapse isOpen={isOpen} navbar className="CllpsMenu align-items-center">
                            <Nav navbar className="mx-auto align-items-center">
                                {menuItems.map(item => (
                                    <NavItem key={item.id}>
                                        <NavLink className={`${activeItem === item.id ? 'active' : ''}`} key={item.id} onClick={() => handleItemClick(item.naviagetto,item.id)}>{t(`${t(item.name)}`)} </NavLink>
                                    </NavItem>
                                ))}
                            </Nav>
                            <Nav navbar className="align-items-center">
                                <NavItem>
                                    <button className="btn LoginBtn my-2" onClick={() => navigate('/login')}>{t('Login')}</button>
                                </NavItem>
                                <NavItem>
                                    <button className='CmnBtn my-2' onClick={() => navigate('/register')}>{t('Register')}</button>
                                </NavItem>
                                <NavItem>
                                    <UncontrolledDropdown className="HdrCntryDD  my-2">
                                        <DropdownToggle>
                                            <img src={languageImages[language]} alt="" />
                                            <img src={require('../../assets/images/down-arrow-white.png')} alt="" />
                                        </DropdownToggle>
                                        <DropdownMenu>
                                        <DropdownItem onClick={() => changeLanguage('english')} disabled={language === 'english'} ><img src={require('../../assets/images/us.svg').default} alt="" /></DropdownItem>
                                                    <DropdownItem onClick={() => changeLanguage('french')} disabled={language === 'french'} ><img src={require('../../assets/images/egypt.svg').default} alt="" /></DropdownItem>
                                                    <DropdownItem onClick={() => changeLanguage('Portuguese')} disabled={language === 'Portuguese'}> <img src={require('../../assets/images/afghanistan.svg').default} alt="" /></DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </NavItem>
                            </Nav>
                        </Collapse>
}
                            </div>                        
                            <button className="mobMenu d-xl-none EpySty" onClick={toggleMenu}>
                                <button className={isActive ? "smClose active EpySty" : "smClose EpySty"} onClick={toggle} >
                                    <svg id="closeicon" viewBox="0 0 800 600">
                                        <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top"></path>
                                        <path d="M300,320 L460,320" id="middle"></path>
                                        <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
                                    </svg>
                                </button>
                            </button> 
                        </div>
                    </nav>
            </header>
    );

}

export default Header;